__webpack_require__.p = "https://apps.leivahnos.com.ar/legales/esquema-de-comisiones/";